import React from 'react'
//=======Material UI
import Grid from '@material-ui/core/Grid'
import useTheme from '@material-ui/core/styles/useTheme'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import useProjectPhase from './useProjectPhase'
import Researcher from './researcher/researcher'
import Officer from './officer/officer'
import useCheckPermission from '../../../../../utilities/checkPermission'
import Dialog from '../../../../../control/dialog/dialog'
import Button from '../../../../../control/button/button'
import useTranslate from '../../../../../i18n/useTranslate'
import constSubmittedStep from '../../../../../constants/submittedStep'
import ButtonSubmittedWithdraw from '../../page/_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'
import useAppFolderAndTabStore from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'

type ProjectPhaseViewType = ReturnType<typeof useProjectPhase> & Omit<ProjectPhaseType, 'projectMode'>
const ProjectPhaseView: React.FC<ProjectPhaseViewType> = (props) => {
    const {
        projectMode,
        isViewMode,
        configDialog,
        projectData,
        onRefDialog,
        onCallbackSaveComplete,
        onClickBackToSearch,
        // onClickCloseProject,
    } = props
    const checkPermission = useCheckPermission()
    const isUserResearcher = checkPermission.isUserResearcher()
    const translate = useTranslate()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData)

    const appFolderAndTabStore = useAppFolderAndTabStore()
    const currentSelectTab = appFolderAndTabStore.tabSelected?.stepID

    const checkConditionBtnClose = () => {
        let isEditDirector = false

        //เช็คว่ามีการกลับมาแก้ไขกรรมการมั้ย และไม่ใช่กรรมการเข้ามาใช่มั้ย (ปุ่มถอนยื่นต้องแสดงทุก step)
        if (projectData?.stepID) {
            isEditDirector = projectData?.stepID >= constSubmittedStep.submit && projectData?.committeeInfo.length >= 0
        }

        // เช็คว่าแก๊งประธานมาตรวจสอบเอกสารในขั้นตอนกำหนดประเภทโครงการมั้ย
        const isChairmanVerifyDoc =
            checkPermission.isUserChairman() && projectData?.stepID === constSubmittedStep.specifyProjectType

        // เช็คว่าผ่านstepการกำหนดประเภทโครงการและกรรมการไปรึยัง และกำลังเปิด tab กำหนดประเภทและกรรมการอยู่ใช่มั้ย
        const isChkStepEditDirector =
            currentSelectTab === constSubmittedStep.specifyProjectType &&
            projectData?.stepID !== constSubmittedStep.specifyProjectType

        let isBtnClose = isChairmanVerifyDoc ? false : isChkStepEditDirector ? isEditDirector : isViewMode

        return isBtnClose
    }

    const renderUserRoleComponent = () => {
        if (isUserResearcher) {
            return <Researcher projectMode={projectMode} callbackSaveComplete={onCallbackSaveComplete} />
        } else {
            return <Officer callbackSaveComplete={onCallbackSaveComplete} />
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid container item>
                {renderUserRoleComponent()}
            </Grid>

            {checkConditionBtnClose() && !canUpdateDocument ? (
                <Grid container item justify="space-between" spacing={2}>
                    <Grid item xs={12} sm={'auto'}>
                        <ButtonSubmittedWithdraw gridProps={{ xs: false }} fullWidth={isMobileView ? true : false} />
                    </Grid>
                    <Grid item xs={12} sm={'auto'}>
                        <Button color="primary" onClick={onClickBackToSearch} fullWidth={isMobileView ? true : false}>
                            {translate.get('BUTTON.CLOSE')}
                        </Button>
                    </Grid>
                </Grid>
            ) : null}

            <Dialog onRef={onRefDialog} {...configDialog} />
        </Grid>
    )
}

export type ProjectPhaseType = {
    projectMode: 'CREATE' | 'EDIT'
}
const ProjectPhase: React.FC<ProjectPhaseType> = (props) => {
    const requestNewProject = useProjectPhase(props)
    return <ProjectPhaseView {...requestNewProject} />
}
export default ProjectPhase
